import {
  Button,
  Distribute,
  Icon,
  Modal,
  SvgInfo,
  Switch,
  Text,
  Tooltip,
} from '@loomhq/lens';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { updateVideoSettings } from 'creators/shareVideo';
import { updateVideoPermissionList } from 'creators/video';

const seoTooltip =
  'Enabling this will allow anyone to find your video using search engines like Google.';

const SearchEngineIndexing = ({ video }) => {
  const dispatch = useDispatch();

  const handleVideoPrivacyChange = publicStatus => {
    dispatch(
      updateVideoSettings({
        allow_search_engine_indexing: publicStatus,
      })
    );
  };

  const [indexingModalIsOpen, setIndexingModalIsOpen] = useState(false);

  const handleIndexingModalConfirm = () => {
    if (video.is_protected) {
      dispatch(updateVideoSettings({}));
    }

    if (video.permitted_viewers_only) {
      dispatch(
        updateVideoPermissionList(
          video.viewer_permission_list.map(email => ({
            email,
            status: false,
          })),
          video.id
        )
      );
    }

    handleVideoPrivacyChange(true);
    setIndexingModalIsOpen(false);
  };

  return (
    <>
      <Distribute isSpread={true}>
        <Distribute gap="xsmall">
          <Text fontWeight="medium" size="small">
            Search engine indexing
          </Text>
          <Tooltip content={seoTooltip} placement="topCenter">
            <Icon icon={<SvgInfo />} size="medium" />
          </Tooltip>
        </Distribute>
        <Switch
          isActive={video.allow_search_engine_indexing}
          onChange={e => {
            const isChecked = e.target.checked;

            if (isChecked) {
              setIndexingModalIsOpen(true);
            } else {
              handleVideoPrivacyChange(false);
            }
          }}
        />
      </Distribute>
      <Modal
        isOpen={indexingModalIsOpen}
        title="Turn on search engine indexing?"
        mainButton={
          <Button
            variant="primary"
            onClick={() => handleIndexingModalConfirm()}
          >
            Yes, turn on
          </Button>
        }
        secondaryButton={
          <Button onClick={() => setIndexingModalIsOpen(false)}>Cancel</Button>
        }
      >
        This will reset all other privacy settings.
      </Modal>
    </>
  );
};

export default SearchEngineIndexing;
